export default [
  /**
   *  KURIKULUM
   */
  {
    path: "/dekan/kurikulum",
    name: "dekan-kurikulum",
    component: () => import("../../views/dekan/kurikulum/Kurikulum.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dekan", url: "/submenu/dekan" },
        { title: "Kurikulum", active: true },
      ],
      pageTitle: "Kurikulum",
    },
  },

  {
    path: "/dekan/kurikulum/lihat-matakuliah/:kurikulumId",
    name: "dekan-kurikulum-matkul",
    component: () =>
      import("../../views/dekan/kurikulum/DetailMatkulKurikulum.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dekan", url: "/submenu/dekan" },
        { title: "Kurikulum", url: "/dekan/kurikulum" },
        { title: "Detail Mata Kuliah", active: true },
      ],
      pageTitle: "Detail Mata Kuliah",
    },
  },
  /**
   *  MAHASISWA
   */
  {
    path: "/dekan/mahasiswa",
    name: "dekan-mahasiswa",
    component: () => import("../../views/dekan/mahasiswa/DataMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dekan", url: "/submenu/dekan" },
        { title: "Mahasiswa", active: true },
      ],
      pageTitle: "Mahasiswa",
    },
  },
  {
    path: "/dekan/mahasiswa/nilai/:userId",
    name: "dekan-mahasiswa-nilai",
    component: () => import("../../views/rektorat/akademik/mahasiswa/NilaiMahasiswa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dekan", url: "/submenu/dekan" },
        { title: "Mahasiswa", url: '/dekan/mahasiswa'},
        { title: "Nilai Mahasiswa", active : true},
      ],
      pageTitle: "Nilai Mahasiswa",
    },
  },
  /**
   *  DOSEN WALI
   */
  {
    path: "/dekan/dosen-wali",
    name: "dekan-dosen-wali",
    component: () => import("../../views/dekan/dosen-wali/DosenWali.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dekan", url: "/submenu/dekan" },
        { title: "Dosen Wali", active: true },
      ],
      pageTitle: "Dosen Wali",
    },
  },
  /**
   *   KELAS
   */
  {
    path: "/dekan/kelas",
    name: "dekan-kelas",
    component: () => import("../../views/dekan/kelas/PlotKelas.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dekan", url: "/submenu/dekan" },
        { title: "Plot Kelas", active: true },
      ],
      pageTitle: "Plot Kelas",
    },
  },

  /**
   *  REKAP PERKULIAHAN
   */

  {
    path: "/dekan/rekap-perkuliahan",
    name: "dekan-rekap-perkuliahan",
    component: () =>
      import("../../views/dekan/rekap-perkuliahan/RekapPerkuliahan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Dekan", url: "/submenu/dekan" },
        { title: "Rekap Perkuliahan", active: true },
      ],
      pageTitle: "Rekap Perkuliahan",
    },
  },
];
